class ContactController {
    /*@ngInject*/
    constructor($log) {
        $log.debug('ContactController initialized');
        this.shopFormVisible = null;
        this.contactFormVisible = null;

        this.companyCountry = null;
        this.companyTopic = null;

        this.shopCountry = null;
        this.shopTopic = null;
    }

    selectFormByType(submittedMailType) {
        if (submittedMailType === 'shop') {
            this.shopFormVisible = true;
            this.contactFormVisible = false;
        } else {
            this.shopFormVisible = false;
            this.contactFormVisible = true;
        }
    }

    currentShopAddressPanel() {
        return this.shopCountry + '-' + this.shopTopic;
    }

    currentCompanyAddressPanel() {
        return this.companyCountry + '-' + this.companyTopic;
    }

    setCompanyAddressPanel(country, topic) {
        this.companyCountry = country;
        this.companyTopic = topic;
        var addressPanel = document.getElementById('company-' + country + '-' + topic);
        if (addressPanel === null) {
            this.companyCountry = 'at';
        }
    }

    setShopAddressPanel(country, topic) {
        this.shopCountry = country;
        this.shopTopic = topic;
        var addressPanel = document.getElementById('shop-' + country + '-' + topic);
        if (addressPanel === null) {
            this.shopCountry = 'at';
        }
    }
}

export default ContactController;
